var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'slide': true, 'legacy': _vm.isLegacy, 'creator-mode': _vm.isCreatorModeEnabled}},[_c('div',{ref:"animations",staticClass:"animations",style:({width: _vm.width + 'px', height: _vm.height + 'px'}),on:{"click":function($event){return _vm.handleClick($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }